<template>
  <!-- <div>
    Replace Image
    <p>Upload ID: {{ this.$route.params.id }}</p>
  </div> -->

  <div class="container pap-form">
    <AlertCard
      v-if="loadingError.isError"
      type="error"
      header="There was a problem..."
    >
      {{ loadingError.message }}
      <p v-if="documentId">Document ID: {{ documentId }}</p>
    </AlertCard>

    <!-- <AlertCard
      v-if="showEditResult"
      :type="resultType"
      :header="resultHeader"
      :message="resultMessage"
    >
      <p class="mt-2 mb-0"><strong>Caption:</strong></p>
      <p>{{ caption }}</p>
      <p class="mt-2 mb-0"><strong>Upload ID:</strong></p>
      <p>{{ documentId }}</p>
    </AlertCard> -->

    <AlertCard
      v-if="showEditResult && resultType === 'error'"
      :type="resultType"
      :header="resultHeader"
      :message="resultMessage"
    >
      <p v-if="documentId">Document ID: {{ documentId }}</p>
    </AlertCard>

    <div
      v-if="showEditResult && resultType === 'success'"
      class="wrapper--center fw-300"
    >
      <CardImage
        :image="uploadedImage"
        header-type="alert"
        alert-header="Image Replacement Successful!"
        type="pending"
        :showHeader="true"
        :showButtonPanel="false"
        :showProductsPanel="false"
        :showUploadDate="false"
      />
    </div>

    <div v-if="showForm" class="card">
      <FormTitle title="Replace Image" iconclass="far fa-image mr-2" />
      <div class="card-body">
        <router-link to="/images-list-pending">
          <div class="pap-form__back">
            <i class="fas fa-caret-left"></i> Back
          </div>
        </router-link>
        <div
          class="pap-form__section pap-form__section--light-gray pap-form__section--mb-2"
        >
          <div class="pap-form__image-wrapper">
            <img alt="" :src="imageThumbURL" />
          </div>
          <p class="mb-0 mt-2 text-center font-weight-bold">{{ caption }}</p>
        </div>

        <b-form novalidate @submit.prevent="doUpload">
          <!-- -------------------------------- Accept Terms checkbox  -->
          <b-form-group
            id="accept-terms"
            label="Agree To Terms"
            label-class="label-bold"
          >
            <b-form-checkbox
              id="agree-terms"
              v-model="agreeTerms"
              name="agree-terms"
              :value="true"
              :unchecked-value="false"
              @change="toggleAgreeTerms"
            >
              <!-- <p class="text-submit text-smaller-1 mb-1">
                I agree to the Pixapup Terms for the use of my dog's image
              </p>
              <p class="text-smaller-1 my-0">The terms (link, etc.)</p> -->

              <p class="pap-form__text m-0">
                I agree to the Pixapup Terms for the use of my dog's image
              </p>
            </b-form-checkbox>

            <p class="text-center text-smaller-1">
              <a href="#" v-b-modal.modal-tos>See Terms of Service</a>
            </p>
          </b-form-group>

          <!-- -------------------------------- Image  -->
          <ImageFileField
            id="main-image"
            label="Dog Image"
            placeholder="Choose an image..."
            @image-selected="imageSelected($event)"
            :state="form.imageFilename.valid"
            :errorMsg="form.imageFilename.errorMsg"
            :disabled="form.imageFilename.disabled"
          />
          <p class="text-center text-smaller-1">
            <a href="#" v-b-modal.modal-image-guide
              >Image Guide: What We're Looking For</a
            >
          </p>

          <!-- -------------------------------- Dog name  -->
          <!-- <b-form-group
            id="dogName-group"
            label="Name of Dog in Image"
            label-for="dogName"
            label-class="label-bold"
            :invalid-feedback="form.dogName.errorMsg"
            :state="form.dogName.valid"
          >
            <b-form-input
              id="dogName"
              maxlength="75"
              placeholder="Dog Name"
              @input="fieldOnInput('dogName')"
              v-model="form.dogName.value"
              :state="form.dogName.valid"
              trim
            ></b-form-input>
          </b-form-group> -->

          <FormErrorAlert
            :showAlert="showFormActionError"
            :msg="formErrorMsg"
          />

          <button
            @click="setSubmitted"
            type="submit"
            class="btn btn-block btn-submit pap-form__btn"
            :disabled="submitDisabled"
          >
            Submit
          </button>
        </b-form>
      </div>
    </div>

    <div :class="overlayClass">
      <div class="page-overlay__content-container">
        <b-spinner label="Spinning" :variant="spinnerColor"></b-spinner>
        <div class="page-overlay__content-text">
          <!-- <div class="page-overlay__process-text-wrapper"> -->
          <p v-show="!uploadCompleted" class="mb-2">Uploading image:</p>
          <p v-show="uploadCompleted" class="mb-2">Image file uploaded!</p>
          <!-- </div> -->

          <b-progress
            :max="uploadProgressMax"
            show-progress
            animated
            height="1.3rem"
            :variant="spinnerColor"
          >
            <b-progress-bar
              :value="uploadProgress"
              :label="`${parseInt(uploadProgress, 10)}%`"
            ></b-progress-bar>
          </b-progress>

          <div class="page-overlay__process-text-wrapper">
            <p v-show="uploadCompleted">
              Just a moment - your upload is processing!
            </p>
            <p v-show="uploadCompleted" mt-2>{{ periods }}</p>
          </div>
        </div>
      </div>
    </div>

    <TOSModal />
    <ImageGuideModal />
  </div>
</template>

<script>
// Get associated thumbnail file name for a given image filename
// and size:  g1.jpg -->> 150px thumb filename = g1_150x150.jpg
function thumbFilename(sourceFilename, size) {
  const fileNameSizeSegment = `_${size}x${size}`;
  const re = /(\.\w+$)/;
  return sourceFilename.replace(re, fileNameSizeSegment + '$1');
}

// Polling to get image URL
function getImageUrl(firebaseApi, imagePath) {
  var maxNumberOfTries = 10;
  var timeBetweenTries = 1000; // interval, in milliseconds

  async function getUrl(trackerObj) {
    trackerObj.count++;
    // console.log('imagePath:', imagePath);
    // console.log('getUrl: Number of tries:', trackerObj.count);
    var imageUrl = await firebaseApi.getImageUrl(imagePath);
    // console.log('imageUrl:', imageUrl);
    if (imageUrl !== 'error') {
      trackerObj.res(imageUrl);
    } else {
      if (trackerObj.count < maxNumberOfTries) {
        setTimeout(getUrl, timeBetweenTries, trackerObj);
      } else {
        trackerObj.res(false);
      }
    }
  }
  // Always resolves: Resolves to imageUrl if/when url is obtained; resolves to false if not (as opposed to rejecting with value false)
  return new Promise((res, rej) => {
    var fileExistsTracker = {
      count: 0,
      result: false,
      res,
    };
    setTimeout(getUrl, 500, fileExistsTracker);
  });
}

import TOSModal from '@/components/modals/TermsOfService';
import ImageGuideModal from '@/components/modals/ImageGuide';

import AlertCard from '@/components/notifications/AlertCard';
import CardImage from '@/components/cards/CardImage';

import FormTitle from '@/components/form/FormTitle.vue';
import ImageFileField from '@/components/form/FormImageFileField';
import FormErrorAlert from '@/components/form/FormErrorAlert.vue';
import { Upload } from '@/models/Upload';

import { mapGetters } from 'vuex';

var imageUploadResultDocListener; // Store the doc listener to call at end to detach

export default {
  name: 'PageImageReplace',
  components: {
    TOSModal,
    ImageGuideModal,
    ImageFileField,
    AlertCard,
    CardImage,
    FormTitle,
    FormErrorAlert,
  },
  data: function () {
    return {
      documentId: '',

      agreeTerms: false,
      caption: '',
      imageThumbURL: '',
      submitDisabled: true,

      // Error reporting: Loading error: Problem loading page, i.e. problem fetching imageUpload document for display
      loadingError: {
        isError: false,
        message: '',
      },
      loadingSuccess: false, // Avoids showing the form while document is being fetched from db

      pageOverlayHidden: true,
      // uploadProgressVal: 0,
      uploadProgressMax: 100,
      uploadCompleted: false,
      periods: '',
      maxNumPeriods: 30, // periods: ... etc. This is for the 'growing periods line' loader in the image-processing phase of the upload process
      timerId: 0,

      resultStatus: '',
      resultStatusMsg: '',
      resultTimestamp: 0,
      resultUploadId: '',
      uploadResultArrived: false,

      // Final result properties, re: handle/fill the AlertCard that displays when upload ends
      showEditResult: false,
      resultType: '',
      resultSuccessMsg: 'Image successfully replaced.',
      resultErrorMsg: '',

      mainImgUrl: '',

      // The upload data model, i.e. this is what's populated via user form data and other programmatically generated data; this is
      // source of data for document in imageUploads collection.
      upload: null,

      image: {
        file: null,
        filename: '',
        src: '',
        size: '',
        height: '',
        width: '',
      },

      imageFilename: '',

      // Set after successful edit; used as prop (named 'image') in CardImage component which is being used as a success alert.
      // THAT comp expects and 'image' prop, which is an obj.
      uploadedImage: {
        docStatus: 'ok',
        creTime: Date.now(),
        dogName: '',
        breed: '',
        caption: '',
        imageThumbURL: '',
      },

      // Form data
      form: {
        imageFilename: {
          value: '',
          disabled: true,
          valid: null,
          errorMsg: '',
        },
      },

      // Text of any overall form error, e.g. validation error, submission result error, etc.
      formErrorMsg:
        'Ooops! Please correct the errors shown in the form above, then click Upload again.',

      // Form validation: true: Every field has a valid value; false: At least one field has an invalid value
      // formValid: false,
      fieldsValid: false,
      // Image file validation: true: Image file passes all validation (packaged in the FormImageFileField component); false; validation failed.
      imageValid: false,

      // Form submission result: Result of form submission (when validated).
      // true: Result of submitted form action was an error; false: Initial state - no error (since form
      // not submitted yet); methods can "reset" this to false to simulate initial state any time after a
      // form submission.
      formError: false,

      // Flag: true: Form submit button was clicked; false: Reset to primitive state, i.e. form not submitted
      formSubmitted: false,
    };
  },

  computed: {
    ...mapGetters(['uploadProgress']),
    ...mapGetters('auth', ['authUser']),

    spinnerColor: function () {
      return this.uploadCompleted ? 'secondary' : 'primary';
    },

    showForm: function () {
      return this.loadingSuccess && !this.showEditResult;
    },
    showFormActionError: function () {
      return (this.formSubmitted && !this.formValid) || this.formError;
    },
    // page-overlay page-overlay--hide
    overlayClass: function () {
      return {
        'page-overlay': true,
        'page-overlay--hide': this.pageOverlayHidden,
      };
    },

    // Form validation: true: Every field has a valid value; false: At least one field has an invalid value
    formValid: function () {
      return this.fieldsValid && this.imageValid;
    },

    resultHeader: function () {
      if (this.resultType === 'success') {
        return 'Success!';
      }
      if (this.resultType === 'error') {
        return 'There was a problem...';
      }
      return '';
    },
    resultMessage: function () {
      return this.resultErrorMsg ? this.resultErrorMsg : this.resultSuccessMsg;
    },
  },

  watch: {
    resultTimestamp: function (newVal, oldVal) {
      // if (!this.resultWatchEnabled) return;
      console.log('resultStatus changed:', newVal, oldVal);
      // if (this.uploadResultListenerInitialized) {

      if (oldVal !== 0 && newVal > oldVal) {
        this.uploadResultArrived = true;
        // this.xx.uploadResultArrived = true;
        // console.log('RRRRR', this.imageUploadResult);
        // this.hideOverlay();

        // Update state with value of file upload result
        this.$store.dispatch('setUploadStatus', this.resultStatus);

        this.processUpload();
      }
      // }
    },

    uploadProgress: function (newVal, oldVal) {
      if (newVal === 100) {
        setTimeout(() => {
          this.uploadCompleted = true;
          this.startPeriods();
        }, 500);
      }
    },
  },

  methods: {
    showOverlay: function () {
      this.pageOverlayHidden = false;
      document.body.classList.add('page-overlay-showing');
    },
    hideOverlay: function () {
      this.pageOverlayHidden = true;
      document.body.classList.remove('page-overlay-showing');
    },

    // Handler for agreeTerms checkbox change
    toggleAgreeTerms: function () {
      this.agreeTerms = !this.agreeTerms;
      Object.keys(this.form).forEach((field) => {
        console.log(field);
        this.form[field].disabled = !this.agreeTerms;
      });
      // Toggle submit button disabled state
      this.submitDisabled = !this.agreeTerms;
      // this.form.imageFilename.disabled = !this.agreeTerms;
      // this.form.dogName.disabled = !this.agreeTerms;
    },
    setSubmitted: function () {
      this.formSubmitted = true;
    },
    resetSubmitted: function () {
      this.formSubmitted = false;
    },

    setField: function (fieldValue, fieldName) {
      this.form[fieldName].value = fieldValue;
      this.fieldOnInput(fieldName);
    },
    // For given field fieldName, on input to the field, i.e. when the value changes, reset the
    // form state to its primitive/original state in terms of form error alerts, form field error alerts, etc.
    fieldOnInput: function (fieldName) {
      console.log('field value changed on:', fieldName);
      this.resetSubmitted(); // Reset 'form submitted' flag to false, i.e. "starting over" as tho form was never submitted.
      this.formError = false;
      if (this.form[fieldName].valid === false) {
        this.form[fieldName].valid = null; // Set to null to not show validation state feedback on the field, i.e. NO red/green styles
        // console.log('test method called on field', fieldName);
        if (fieldName === 'country') {
          this.form.province.value = '';
        }
      }
    },

    // imageSelected: function (imageObj) {
    //   this.image = imageObj;
    //   this.form.imageFilename.value = imageObj.filename;
    //   this.fieldOnInput('imageFilename');
    // },
    // Param: imgDataObj: { image: image object, validationError:'Image validation error string' }
    imageSelected: function (imgDataObj) {
      console.log('Image Selected Data Obj:', imgDataObj);
      this.imageValid = false;
      this.image = imgDataObj.image;
      this.form.imageFilename.value = imgDataObj.image.filename;
      if (imgDataObj.validationError) {
        this.form.imageFilename.valid = false; // Set to false to show validation state feedback of 'invalid', i.e. red styles
        this.form.imageFilename.errorMsg = imgDataObj.validationError;
      } else {
        this.imageValid = true;
        this.fieldOnInput('imageFilename');
      }
    },

    generatePeriods: function () {
      var currentPeriods = this.periods;
      if (currentPeriods.length <= this.maxNumPeriods) {
        this.periods = currentPeriods + '.';
      } else {
        this.periods = '';
      }
    },
    startPeriods: function () {
      this.timerId = setInterval(this.generatePeriods, 200);
    },
    stopPeriods: function () {
      clearInterval(this.timerId);
    },
    doSelectedImage: function (e) {
      var selectedFile = e.target.files[0];
      // console.dir(selectedFile);
      if (!selectedFile) return;
      var objUrl = URL.createObjectURL(selectedFile);
      this.image.src = objUrl;
      this.image.size = selectedFile.size;
      this.image.filename = selectedFile.name;
      this.form.imageFilename.value = selectedFile.name;
      const img = document.createElement('img');
      img.src = objUrl;
      var vm = this;
      img.onload = function () {
        var { width, height } = this;
        vm.image.height = height;
        vm.image.width = width;
        URL.revokeObjectURL(this.src);
      };
      console.log(this.image);
    },

    validate: function () {
      var formData = {};
      Object.keys(this.form).forEach((fieldName) => {
        formData[fieldName] = this.form[fieldName].value;
      });

      var upload = Upload.update(formData); // Validation here so, test if validation passed next...

      console.log('upload', upload);
      // return;

      // console.log('upload data', upload);
      // this.formValid = Upload.validationPassed();
      this.fieldsValid = Upload.validationPassed();

      // Reset form field values to display latest 'state' of form after validation/sanitization/etc.
      Object.keys(upload).forEach((fieldName) => {
        // Since, e.g. imageFilename, is NOT in the this.form object... do this if check
        // if (this.form[fieldName] !== undefined) {
        this.form[fieldName].value = upload[fieldName];
        // }
      });

      // if (!this.formValid) {
      if (!this.fieldsValid) {
        // this.formErrorMsg =
        //   'Ooops! Please correct the errors shown in the form above, then click Upload again.';
        Upload.validationErrors().forEach((err) => {
          var propName = Upload.getErrorProp(err);
          console.log('prop', propName);
          this.form[propName].valid = false; // Set to false to show validation state feedback of 'invalid', i.e. red styles
          this.form[propName].errorMsg = Upload.getErrorMsg(err);
          console.log(propName, Upload.getErrorMsg(err));
        });
      }
      this.upload = upload;
    },

    createUploadResultDocListener: function () {
      var resultDocRef = this.$fapi.db
        .collection('uploadResults')
        .doc(this.authUser.uid);

      // Var defined top of file as 'global' since need access in another method (and didn't need to attach it
      // to vue instance ... no need). Will call this at final step of upload to detach the listener.
      imageUploadResultDocListener = resultDocRef.onSnapshot((doc) => {
        var { status, statusMsg, timestamp, uploadId } = doc.data();
        console.log(status, statusMsg, timestamp, uploadId);
        // Initially (before the first upload), uploadId is not defined
        // on the upload result doc.
        // If uploadId isn't defined, set it to empty str since we're setting
        // instance properties next and this is one of them.
        if (!uploadId) {
          uploadId = '';
        }
        // Set local instance props to match doc values, i.e. sync up the
        // doc with the instance
        this.resultStatus = status;
        this.resultStatusMsg = statusMsg;
        this.resultTimestamp = timestamp;
        this.resultUploadId = uploadId; // not needed since documentId set in created()
      });
    },

    ui_onUploadEnd: function () {
      this.hideOverlay();
      // this.$router.push('/upload-result');
      this.showEditResult = true;
    },

    doUpload: async function () {
      // **************** TESTING *******************************************
      // var imageUploadRef = this.$fapi.getDocRefById(
      //   'imageUploads',
      //   'dKtCNDHcqpJGQxnH0Cj6' // a doc for user: simon@smith.com
      // );
      // // this.upload.updatedAt = this.$fapi.firebase.firestore.FieldValue.serverTimestamp();
      // try {
      //   await imageUploadRef.update({
      //     test: 'myTest',
      //     updatedAtXXX: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
      //   });
      //   console.log('UPDATE succeeded');
      // } catch (error) {
      //   console.error('UPDATE failed:', error.message);
      // }
      // console.log('done with update test');
      // return;
      // var trackerRef = this.$fapi.getDocRefById(
      //   'uploadTrackers',
      //   'DPkrWNXdgZUliesQNVL0HTlNY0p2' // a doc for user: simon@smith.com
      // );
      // var doc = await trackerRef.get();
      // var docData = doc.data();
      // console.log(docData.imageNamesAll);
      // return;

      // In the state, reset (i.e. set to zero) the number of upload tracker doc changes, insuring we start this upload 'cleanly' in terms
      // of that number (since there are TWO doc changes in a new upload and at that point, the doc listener takes certain action).
      this.$store.dispatch('resetNumUploadTrackerChanges');
      // ***** >>>> But, for THIS edit upload op (vs an original upload), are there TWO uploadTracker changes? Or just ONE?
      //              If just ONE, then need to set number-tracker-changes to 1 (one), NOT zero (since the listener function right
      //              now is hard-coded to listen for TWO then take action)

      // --------------- Validate form data
      this.validate();
      if (!this.formValid) return;

      this.$store.dispatch('setUploadInProgress', true);
      this.showOverlay();

      this.createUploadResultDocListener();

      // 2. AWAIT image upload
      var metaData = {
        h: this.image.height,
        w: this.image.width,
        filename: this.image.filename,
        atos: true,
        edit: this.documentId,
      };
      // console.log('METADATA', metaData);
      // return;

      // Note: Setting metadata here means the thumbnail img created after upload also gets this same metadata... but that's ok.
      try {
        await this.$fapi.uploadImage(
          'dogimgs/' + this.authUser.uid,
          this.image.file,
          this.$store,
          metaData
        );
      } catch (err) {
        // err is string here
        // uploadError = true;
        console.log('UPLOAD ERROR: Type: Executing Upload:', err);
        // this.formError = true;
        // this.formErrorMsg =
        this.$store.dispatch('setUploadStatus', 'e_upload_exec_error');
        this.$store.dispatch('setUploadInProgress', false);
        this.$store.dispatch('setUploadCompleted', true);
        this.resultType = 'error';
        this.resultErrorMsg = 'Change Image upload failed: ' + err;
        this.ui_onUploadEnd();
      }

      // var imageUploadRef = this.$fapi.getDocRefById(
      //   'imageUploads',
      //   this.documentId
      // );
    },

    // Called after the 'upload' method, once the upload result has arrived (see in 'watch').
    processUpload: async function () {
      var mainErrorMessagePrefix = 'Change Image upload failed: ';
      var mainErrorMessage = `Looks like there was a problem with either the original
            upload or THIS "Change Image" upload. You should DELETE this upload (on the Uploads list page), then try uploading again.`;

      // If upload status NOT ok (per 'message' from server), abort: Show result page with error alert/notice.
      if (this.resultStatus !== 'ok') {
        // this.formError = true;
        // this.formErrorMsg = this.resultStatus;
        this.$store.dispatch('setUploadInProgress', false);
        this.$store.dispatch('setUploadCompleted', true);
        this.resultType = 'error';
        this.resultErrorMsg =
          'Image upload edit failed: ' + this.resultStatusMsg;
        this.ui_onUploadEnd();
        return;
      }

      // NO FILE UPLOAD error at this point so: Need to update/finalize imageUploads document associated
      // with THIS upload.  Get that doc ID from the uploadResult document.
      var uid = this.authUser.uid;

      var imageUploadRef = this.$fapi.getDocRefById(
        'imageUploads',
        this.documentId
      );

      // 1. Get URLs of main image and thumbnail image
      var imageFilename = this.image.filename;
      var uploadDoc = await imageUploadRef.get();
      if (uploadDoc.exists) {
        // Get main image URL -------------------------------
        var mainImgUrl = await getImageUrl(
          this.$fapi,
          'dogimgs/' + uid + '/' + imageFilename
        );

        // console.log('ThumbUrl', thumbnailImgUrl);
        // var mainImgUrl = await this.$fapi.getImageUrl(
        //   'dogimgs/' + uid + '/' + imageFilename
        // );

        // Get thumbnail image URL -------------------------------
        var thumbNailPath = 'dogimgs/' + uid + '/thumbs/';
        var thumbnailImgUrl = await getImageUrl(
          this.$fapi,
          thumbNailPath + thumbFilename(imageFilename, 200)
        );

        // var thumbNailPath = 'dogimgs/' + uid + '/thumbs/';
        // var thumbnailImgUrl = await this.$fapi.getImageUrl(
        //   thumbNailPath + thumbFilename(imageFilename, 200)
        // );

        console.log('MainUrl', mainImgUrl);

        // this.mainImgUrl = mainImgUrl;

        this.upload.imageURL = mainImgUrl;
        this.upload.imageThumbURL = thumbnailImgUrl;

        //upload.usageStatus = 'pending';

        // --------- Set other upload properties (streamline this???):

        // serverTimestamp
        // (per firestore rules, absolutely NEED this to allow update; update fails without this (helps deter rogue user
        // who is not aware of this))
        this.upload.updatedAt = this.$fapi.firebase.firestore.FieldValue.serverTimestamp();

        console.log('UPLOAD OBJ:', this.upload);

        // ------- End setting other upload properties

        // Set new thumbnail image URL - used in success alert message card
        this.uploadedImage.imageThumbURL = thumbnailImgUrl;

        // console.log(Upload.getSnapshot(this.upload));
        // Do the db doc update
        try {
          // This update of the imageUpload doc will throw error due to fb security rules: Existing imageUpload doc
          // MUST have both image URLs populated; if either one is empty --- AND one/both of the image URLS fetched above
          // is malfomred, i.e. value is 'error, i.e. doesn't match allowed characters format of a URL ---  it's a signal that
          // either image upload (orig or a prev replacement) did not go to completion. If THAT'S the
          // case, user is notified to delete this upload.
          await imageUploadRef.update(Upload.getSnapshot(this.upload));
          this.resultType = 'success';
        } catch (err) {
          this.resultType = 'error';
          this.resultErrorMsg =
            mainErrorMessagePrefix + mainErrorMessage + ' Error Code: PE'; // err.message;
          // Since the imageUpload update in the try block imm. above failed, that update doesn't occur; therefore, the uploadsTracker
          // doc update doesn't occur and so the listener function on that doc doesn't fire leaving the uploadTracker number of
          // changes at one (1) -- never gets to two so the setUploadProgress state prop stays at true; so, force it to false here
          // (so that UI state is proper, e.g. show the 'Delete' button on each image card, etc.).
          this.$store.dispatch('setUploadInProgress', false);
        }
      }

      // Detach listener
      //imageUploadResultDocListener();

      // Set upload progress back to zero in state
      this.$store.dispatch('setUploadProgress', 0);

      // Signal that upload process has completed
      this.$store.dispatch('setUploadCompleted', true);

      // Handle UI
      this.ui_onUploadEnd();
    },
  },
  created: async function () {
    // console.log('ROUTE', this.$route);
    this.$store.dispatch('setUploadProgress', 0);
    this.$store.dispatch('setUploadStatus', '');
    this.$store.dispatch('setUploadInProgress', false);
    this.$store.dispatch('setUploadCompleted', false);

    this.documentId = this.$route.params.id;

    try {
      var imageUploadRef = this.$fapi.getDocRefById(
        'imageUploads',
        this.$route.params.id
      );
      var uploadDoc = await imageUploadRef.get();
      if (!uploadDoc.exists) {
        throw Error('Document not found in the database.');
      }

      if (uploadDoc.data().usageStatus !== 'pending') {
        throw Error(
          'Permission denied: Selected, Published, or Unusable images cannot be edited.'
        );
      }
      for (var field in this.form) {
        // this.form[field].value = uploadDoc.data()[field];
      }
      // Set imageFilename: Used in validation (since it's a required field but not being loaded in this form)
      // this.imageFilename = uploadDoc.data().imageFilename;

      this.caption = uploadDoc.data().caption;

      this.imageThumbURL = uploadDoc.data().imageThumbURL;

      // Populate the uploadedImage object for CardImage component success alert.
      // All props in this obj - EXCEPT the imageThumbURL - do not change (since this page is just new image file upload).
      this.uploadedImage.dogName = uploadDoc.data().dogName;
      this.uploadedImage.breed = uploadDoc.data().breed;
      this.uploadedImage.caption = this.caption;

      this.loadingSuccess = true;
    } catch (err) {
      this.loadingError.isError = true;
      this.loadingError.message =
        'Failed to load Image Upload document for editing: ' + err.message;
      console.log('ERROR loading upload doc', err.message);
    }
  },
};
</script>

<style>
</style>